<template>
  <div
    class="connect-banner md:text-xxl text-m text-center 2xl:px-52 px-14 py-10"
  >
    <h2 class="mx-auto">
      {{ $t("wegow.banner.connectFriends.title") }}
    </h2>
    <a :href="getUrl()">
      <wegow-button
        button-id="banner-connect-button"
        background="opacity"
        color="topaz-light"
        type="button"
        size="banner-xxl"
        :text="$t('wegow.banner.connectFriends.button')"
        @click="sendGa('connect-friends')"
      />
    </a>
  </div>
</template>

<script setup>
import WegowButton from "@/components/general/forms/WegowButton";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import { useGeneral } from "@/composables/useGeneral";

const { footerInfo, navbarInfo } = useGeneral();
const route = useRoute();
const { t } = useI18n();

const getUrl = () => {
  let url =
    "/" +
    (route.params.region || "es") +
    "/" +
    t("wegow.filters.people").toLowerCase();
  url +=
    "/geo/" +
    (navbarInfo.value?.country_slug ||
      footerInfo.value?.country_slug ||
      "espana");
  return url;
};
const sendGa = () => {
  gtag("event", "connect-friends", {
    event_category: "social"
  });
};
</script>

<style scoped lang="scss">
.connect-banner {
  justify-content: flex-start;
  height: 370px;
  width: 100%;
  background-image: url("@/assets/images/conect-friends-fb-banner.webp");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white !important;
  // h2 {
  //   font-weight: 600;
  //   // font-size: 2.5vw;
  //   line-height: 48px;
  //   margin-bottom: 45px;
  // }
  @media screen and (max-width: $screen-lg) {
    height: 128px;
    gap: 11px;
  }

  h2 {
    font-size: 0.75rem; // 12px
    font-weight: 600;
    text-align: center;
    line-height: normal;
    @media screen and (min-width: $screen-lg) {
      font-size: 2rem; // 32px
      margin-bottom: 30px;
    }
    @media screen and (min-width: $screen-xl) {
      font-size: 2.5rem; // 40px
      margin-bottom: 30px;
    }
  }
  p {
    font-weight: 400;
    font-size: 25px;
    line-height: 30px;
    margin-top: 11px;
    margin-bottom: 40px;
  }
}
</style>
